module.exports = __webpack_public_path__ + "img/mark.77f27738.svg";